export const RESET = 'EXCMCYCLICTASK_LIST_RESET'
export const SET_ITEMS = 'EXCMCYCLICTASK_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMCYCLICTASK_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMCYCLICTASK_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMCYCLICTASK_LIST_TOGGLE_LOADING'
